<template>
  <div class="workbench-container">
    <header class="top-nav">
      <div class="nav-left">
        <div class="logo">
          <img src="../../static/image/desktop/零数通 .png" alt="" class="icon-img">
        </div>
        <span class="nav-title">零数通 · 工作台</span>
      </div>
      <div class="nav-right">
        <div class="user-info">
          <div class="avatar">{{ getFirstChar(userName) }}</div>
          <span class="user-name">{{ userName }} · {{ roleName }} </span>
        </div>
        <button class="logout-btn" @click="loginout">
          <img src="../../static/image/desktop/退出登录.png" alt="" class="icon-img-small">
          退出登录
        </button>
      </div>
    </header>

    <main class="main-content">
      <div class="greeting-section">
        <p class="date-text">{{ currentDate }}</p>
        <h1 class="greeting-text">{{ greeting }}{{ userName }}</h1>
      </div>

      <div class="content-grid">

        <!-- 左侧企业服务 -->
        <div class="left-column">
          <h3 class="section-title">企业服务</h3>
          <div class="service-list">
            <div class="service-item" v-for="item in leftMenus" :key="item.menuCode" @click="openMenuUrl(item)">
              <div class="item-icon">
                <img :src="item.icon" alt="" class="icon-img">
              </div>
              <span class="item-name">{{ item.menuName }}</span>
              <svg class="arrow-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 12L10 8L6 4" stroke="#999" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- 右侧运营工具 -->
        <div class="right-column">
          <h3 class="section-title">运营工具</h3>
          <div class="tools-grid">
            <div class="tool-item" v-for="item in rightMenus" :key="item.menuCode" @click="openMenuUrl(item)">
              <div class="tool-icon">
                <img :src="item.icon" alt="" class="icon-img">
              </div>
              <span class="tool-name">{{ item.menuName }}</span>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: 'Workbench',
  data() {
    return {
      currentDate: '', // 日期：2026年4月30日 · 周四
      greeting: '',    // 早上/下午/晚上好
      leftMenus: [],
      rightMenus: [],
    }
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timer)
  },
  mounted() {
    // 初始化
    this.getTime()
    // 每秒更新
    this.timer = setInterval(() => {
      this.getTime()
    }, 1000)
    const storeMenu = localStorage.getItem('leftMenus')
    if (storeMenu) {
      this.leftMenus = JSON.parse(storeMenu)
    }
    const storeRightMenu = localStorage.getItem('rightMenus')
    if (storeRightMenu) {
      this.rightMenus = JSON.parse(storeRightMenu)
    }
  },
  computed: {
    userName: function () {
      return localStorage.getItem("userName")
    },
    roleName: function () {
      return localStorage.getItem("roleName");
    },
  },
  methods: {
    // 获取用户名第一个字
    getFirstChar(name) {
      if (!name) return ''
      return name.charAt(0)
    },
    getTime() {
      const date = new Date()

      // 1. 格式化日期：2026年4月30日 · 周四
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const week = '周' + ['日', '一', '二', '三', '四', '五', '六'][date.getDay()]
      this.currentDate = `${year}年${month}月${day}日 · ${week}`

      // 2. 自动判断 上午/下午/晚上
      const hour = date.getHours()
      if (hour < 6) {
        this.greeting = '凌晨好，'
      } else if (hour < 12) {
        this.greeting = '上午好，'
      } else if (hour < 18) {
        this.greeting = '下午好，'
      } else {
        this.greeting = '晚上好，'
      }
    },
    openMenuUrl(item) {
      if (!item.url) {
        this.$message.info('敬请期待')
        return
      }
      window.location.href = item.url
    },
    // 退出登录事件
    loginout: function () {
      this.$store.commit("setToken", "");
      this.$store.commit("setAccount", "");
      Cookies.set("token", "");
      Cookies.set("account", "");
      Cookies.set("retailink-roleCode", "");
      // todo: 退出登录的时候,清空标题和退出时候的路由
      // this.$store.commit("setMenuTitle", "");
      // this.$store.commit("setMenuHighLight", "");
      // this.$router.push('/login')
      window.location.replace("https://uat.lingshutong.cn/#/login")
    }
  },
}
</script>

<style scoped>
.workbench-container {
  min-height: 100vh;
  background-color: #f0f0f0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-title {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #52C41A;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}

.user-name {
  font-size: 16px;
  color: #666;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 14px;
}

.main-content {
  padding: 32px 48px;
}

.greeting-section {
  margin-bottom: 32px;
}

.date-text {
  color: #999;
  font-size: 14px;
  margin: 0 0 8px 0;
}

.greeting-text {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.content-grid {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 32px;
}

.left-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin: 0;
}

.service-list {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.service-item {
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background .2s;
}

.service-item:last-child {
  border-bottom: none;
}

.service-item:hover {
  background: #fafafa;
}

.item-icon {
  margin-right: 12px;
}

.item-name {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.arrow-icon {
  opacity: 0.6;
}

.right-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tools-grid {
  background: #fff;
  border-radius: 8px;
  padding: 32px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 24px;
}

.tool-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all .2s;
}

.tool-item:hover {
  background: #fafafa;
}

.tool-item.active {
  background: #f5f5f5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.tool-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tool-name {
  font-size: 14px;
  color: #333;
  text-align: center;
}

.icon-img {
  width: 24px;
  height: 24px;
}

.icon-img-small {
  width: 16px;
  height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/desktop.vue